/** Resting + focus shell shared by Hot Takes and Biggest Prize Pools cards. */
export const RIGHT_COLUMN_CARD_BASE =
  'group relative overflow-hidden rounded-card border-solid border-border-primary [border-width:var(--border-width-hairline)] bg-background-primary p-3 dark:border-border-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-border-primary' as const;

/** Hover lift — rests flat, lifts to the `card` role on hover (both modes).
 *  The exact treatment `RIGHT_COLUMN_CARD_PRIZE_SHELL` uses, so the two
 *  right-column cards lift identically. */
export const RIGHT_COLUMN_CARD_HOVER =
  'transition-[box-shadow] duration-fast ease-default motion-reduce:transition-none hover:shadow-elevation-card' as const;

/** Resting + hover + focus — the Hot Takes card surfaces. Hover elevation
 *  matches the Biggest Prize Pools card (MOR-855: align hover states across
 *  the right-column cards; supersedes the MOR-842 removal). */
export const RIGHT_COLUMN_CARD_LINK_CHROME =
  `${RIGHT_COLUMN_CARD_BASE} ${RIGHT_COLUMN_CARD_HOVER}` as const;

export const RIGHT_COLUMN_CARD_GLOW_BASE =
  'pointer-events-none absolute inset-0 rounded-card opacity-15' as const;

/**
 * Prize card cover sits above the link surface, hiding the base card's shadow.
 * Mirror the hover lift on a layer above the cover so the card still lifts.
 */
export const RIGHT_COLUMN_CARD_PRIZE_HOVER_OVERLAY =
  'pointer-events-none absolute inset-0 z-[1] rounded-card transition-[box-shadow] duration-fast ease-default motion-reduce:transition-none group-hover:shadow-elevation-card' as const;

/** Non-interactive resting shell — skeletons and static placeholders. */
export const RIGHT_COLUMN_CARD_RESTING_SHELL =
  'relative overflow-hidden rounded-card border-solid border-border-primary [border-width:var(--border-width-hairline)] bg-background-primary p-3 dark:border-border-primary' as const;

/**
 * Full-bleed prize leaderboard shell — same chrome as the base card but
 * WITHOUT `p-4`, so the active row's cover image reaches the card edges.
 * Header + rows manage their own inner padding.
 */
export const RIGHT_COLUMN_CARD_PRIZE_SHELL =
  'relative flex min-h-0 flex-1 flex-col overflow-hidden rounded-card border-solid border-border-primary [border-width:var(--border-width-hairline)] bg-background-primary transition-[box-shadow,border-color] duration-fast ease-default motion-reduce:transition-none dark:border-border-primary hover:shadow-elevation-card' as const;
